export const networkColors = {
    instagram: "#A032AC",
    facebook: "#3B5998",
    twitter: "#55ACEE",
    youtube: "#CE1312",
    tiktok: "#000"
}